import { render } from "./AddTransfertPage.vue?vue&type=template&id=45926738&ts=true"
import script from "./AddTransfertPage.vue?vue&type=script&lang=ts"
export * from "./AddTransfertPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__